<template>
  <button class="page-button" :disabled="selected">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'PageButton',
  props: {
    selected: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
  .page-button {
    display: inline-block;
    width: 48px;
    height: 48px;
    color: #ec8dae;
    text-decoration: none;
    vertical-align: middle;
    font-size: 24px;
    line-height: 48px;
    background-color: transparent;
    border: none;
    outline: none;
    padding: 0;
    appearance: none;
  }

  .page-button:disabled {
    color: #fff;
    background: #ec8dae;
    border-color: #ec8dae;
    border-radius: 50%;
    pointer-events: none;
  }

  .page-button:hover {
    color: #fff;
    background: #ec8dae;
    border-color: #ec8dae;
    border-radius: 50%;
    cursor: pointer;
  }
</style>
